import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import usePageTitle from "@/hooks/use-page-title";
import { fmtDate, fmtDateTime } from "@/lib/date";

export default function CustomerPayments() {
  usePageTitle("My Payments");
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/payments").then((r) => setRows(r.data)); }, []);
  const total = rows.reduce((s, p) => s + Number(p.amount || 0), 0);

  return (
    <div className="space-y-6" data-testid="my-payments-root">
      <div className="border-b border-[hsl(var(--border))] pb-6 flex items-end justify-between">
        <div>
          <div className="overline mb-2">Customer</div>
          <h1 className="font-display text-4xl font-black tracking-tighter">My Payments</h1>
        </div>
        <div className="text-right">
          <div className="overline">Total paid</div>
          <div className="font-mono font-black text-3xl text-[#FF6B00]">₹{Math.round(total).toLocaleString("en-IN")}</div>
        </div>
      </div>
      <div className="card-swiss overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[hsl(var(--border))]">
              <th className="px-4 py-3 text-left overline">Date</th>
              <th className="px-4 py-3 text-left overline">Order</th>
              <th className="px-4 py-3 text-left overline">Mode</th>
              <th className="px-4 py-3 text-left overline">Note</th>
              <th className="px-4 py-3 text-right overline">Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} className="border-b border-[hsl(var(--border))]" data-testid={`my-pay-${p.id}`}>
                <td className="px-4 py-3 text-xs font-mono">{fmtDate(p.created_at)}</td>
                <td className="px-4 py-3"><Link to={`/orders/${p.order_id}`} className="font-mono text-xs hover:text-[#FF6B00]">{p.order_id}</Link></td>
                <td className="px-4 py-3 uppercase text-xs font-semibold">{p.mode}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{p.note || "—"}</td>
                <td className="px-4 py-3 text-right font-mono">₹{Math.round(p.amount).toLocaleString("en-IN")}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={5} className="py-12 text-center text-muted-foreground">No payments yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
